// extracted by mini-css-extract-plugin
export default {"message":"rtAEK","countdown":"_23PiY","countdown-value":"_2Kzl7","countdownValue":"_2Kzl7","countdown-ended":"_1uwCC","countdownEnded":"_1uwCC"};